module.exports = __webpack_public_path__ + "static/img/fs1-4.655cb9f.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/fs1-4.png
// module id = 844
// module chunks = 0